import { useSelector, useDispatch } from 'react-redux';
import selectors from 'store/selectors';
import CustomDialog from 'components/CustomDialog/customDialog';
import { setDialog } from 'store/actions/dialogActions';
import { ContentCnt } from './RemoveDialog.style';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';
import DIALOGS from 'utils/dialogIds';
import { Box, Button, Typography } from '@mui/material';
import xeniaApi from 'api/index';
import actions from 'store/actions';

const RemoveAnnouncementDialog = () => {
  const dispatch = useDispatch();
  const dialogState = useSelector(selectors.getDialogState);
  const { open, data = {} } =
    dialogState?.[DIALOGS?.REMOVE_ANNOUNCEMENT_DIALOG] || {};
  const { announcement, tab } = data;

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialogId: DIALOGS?.REMOVE_ANNOUNCEMENT_DIALOG,
      }),
    );
  };

  const handleDelete = async () => {
    try {
      // Call API to delete the announcement
      await xeniaApi.removeAnnouncement(announcement.id);

      const postObj = {
        status: tab,
      };
      const announcementsApiResponse = await xeniaApi.getAnnouncements(postObj);
      if (announcementsApiResponse) {
        dispatch(actions.setAnnouncements(announcementsApiResponse));
      }
      // Close the dialog
      handleClose();
    } catch (error) {
      console.error('Error deleting announcement:', error);
      // Optionally show an error message to the user
    }
  };

  if (!announcement) return null;

  return (
    <CustomDialog
      // hideActions={true}
      header={
        <CustomDialogHeader onClose={handleClose}>
          <Typography fontSize={'20px'} fontWeight={700}>
            Remove Announcement
          </Typography>
          <Typography fontSize={'16px'} fontWeight={500} color={'#424242'}>
            {announcement.title}
          </Typography>
        </CustomDialogHeader>
      }
      actionButtonCntProps={{
        primaryBtnProps: {
          color: 'error',
          sx: {
            background: '#EF5350',
          },
          onClick: handleDelete,
        },
        secondaryBtnProps: {
          sx: {
            color: '#212121',
          },
          onClick: handleClose,
        },
      }}
      primaryBtnText="Yes, Remove"
      dialogProps={{
        open: open,
        maxWidth: true,
        onClose: handleClose,
        sx: {
          '& .MuiDialog-paper': {
            maxWidth: '600px',
          },
        },
      }}
    >
      <ContentCnt>
        <Box sx={{ p: 3 }}>
          <Typography
            variant="body1"
            sx={{ mb: 3, fontWeight: 500, fontSize: '16px' }}
          >
            This will permanently remove the announcement, and recipients will
            no longer be able to view it.
          </Typography>

          <ul
            style={{
              marginBottom: '20px',
            }}
          >
            <li
              style={{
                listStyle: 'disc',
              }}
            >
              <Typography
                variant="body2"
                sx={{ mb: 1, fontWeight: 500, fontSize: '16px' }}
              >
                This will remove the announcement from the active list and move
                it to the Past tab.
              </Typography>
            </li>
            <li
              style={{
                listStyle: 'disc',
              }}
            >
              <Typography
                variant="body2"
                sx={{ mb: 1, fontWeight: 500, fontSize: '16px' }}
              >
                Recipients will no longer receive notifications or see it in
                their active announcements.
              </Typography>
            </li>
          </ul>

          <Typography
            variant="body1"
            sx={{ mb: 4, fontWeight: 500, fontSize: '16px' }}
          >
            This action <b>cannot be undone.</b>
            <br />
            <b>Are you sure you want to remove this announcement?</b>
          </Typography>
        </Box>
      </ContentCnt>
    </CustomDialog>
  );
};

export default RemoveAnnouncementDialog;
